import React from 'react';
import { Chip, Paper, TextField, Autocomplete, createFilterOptions } from '@mui/material';
import PropTypes from 'prop-types';

import localization from '../../localization';

const filter = createFilterOptions();
const getOptionLabel = (option) => option?.isCreated ? option.label : option;
const getOptionValue = (option) => option?.isCreated ? option.value : option;

const MultiSelectCreatable = ({
  label,
  currentValue = [],
  options = [],
  isDisabled = false,
  isRequired = false,
  onSelect = () => {},
}) => {
  const onChange = (event, newValue) => {
    const newSelected = newValue.map(getOptionValue);
    onSelect(newSelected);
  };

  const filterOptions = (currentOptions, params) => {
    const { inputValue } = params;
    const isExisting = currentOptions.some((option) => inputValue === option);
    const filtered = filter(currentOptions, params);

    if (inputValue !== '' && !isExisting) {
      filtered.push({
        value: inputValue,
        label: `${localization.t('labels.add')} "${inputValue}"`,
        isCreated: true,
      });
    }

    return filtered;
  };

  return (
    <Autocomplete
      fullWidth
      multiple
      freeSolo
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      id="tags-creatable"
      disabled={isDisabled}
      value={currentValue}
      onChange={onChange}
      options={options}
      filterSelectedOptions
      filterOptions={filterOptions}
      getOptionLabel={getOptionLabel}
      renderTags={(value, getTagProps) => value?.map((option, index) => (
        <Chip
          key={option}
          label={option}
          variant="outlined"
          {...getTagProps({ index })}
        />
      ))}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          required={isRequired}
          label={label}
        />
      )}
      PaperComponent={({ children }) => (
        <Paper style={{ marginBottom: 10 }}>{children}</Paper>
      )}
    />
  );
};

MultiSelectCreatable.propTypes = {
  label: PropTypes.string.isRequired, // localized string
  currentValue: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string),
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  onSelect: PropTypes.func, // (value: String[]) => void
};

export default MultiSelectCreatable;
